import { gql } from "@apollo/client";

export const FILTER_OPPORTUNITIES = gql`
  query filterOpportunitiesPaginated(
    $paginationInput: PaginationInput!
    $status: OpportunityStatusEnum
  ) {
    filterOpportunitiesPaginated(
      paginationInput: $paginationInput
      status: $status
    ) {
      data {
        id
        channel
        channelUserId
        kind
        text
        status
        offeringId
        createdAt
      }
      paginationInfo {
        itemCount
        pageCount
        currentPage
      }
    }
  }
`;

export const UPDATE_OPPORTUNITY_STATUS = gql`
  mutation updateOpportunityStatus($id: String!, $status: OpportunityStatusEnum!) {
    updateOpportunityStatus(id: $id, status: $status) {
      id
      status
    }
  }
`;
